export default __webpack_public_path__ + "static/media/mdi--eraser.8a29ac56.svg";